import React, {Component} from 'react'
import {
    Form,
    Input,
    Row,
    Col,
    Select,
    DatePicker,
    Button,
    Table
} from 'antd';
import {reqKtLogisticsList} from '../../api'
import LinkButton from '../../components/link-button'
import authorizeBase from "../../components/authorize/authorizeBase";
const AuthLinkButton = authorizeBase(LinkButton)
const {Option} = Select;

const orderStatus = {
    unbooked: '订舱中',
    booked: '订舱成功',
    declare: '待报关',
    declaring: '报关中',
    released: '已放行',
    cancelled: '已取消'
};

const logisticsStatus = {
    waiting: "待提货",
    transport: '运输中',
    declaring: '报关中',
    released: '已放行',
    destination: '已到达',
    cancelled: '已取消'
};
class KtTrackList extends Component {

    state = {
        total: 0, // 商品的总数量
        orderList: [], // 商品的数组
        pageNum: 1,
        searchData: {},
        selectList: [],
        deliveryFromDt: null,
        deliveryToDt: null,
        sortData: {}
    };

    /*
     初始化table的列的数组
     */
    initColumns = () => {
        this.columns = [
            {
                title: '订单编号',
                dataIndex: 'orderNo',
                sorter: true,
                width: 140,
                render: (text, record) => (
                    <span>
                       <LinkButton
                           onClick={() => this.props.history.push('/ktTrackDetail', {orderId: record.id})}>{text}</LinkButton>
                    </span>
                )
            },
            {
                title: '揽收单位',
                dataIndex: 'entName',
            },
            {
                title: '起运地',
                sorter: true,
                dataIndex: 'originCity',
                render: (text, record) => (
                    <span>
                        {record.originCountry}&nbsp;{text}
                  </span>
                )
            }, {
                title: '目的地',
                sorter: true,
                dataIndex: 'destinationCountry',
                render: (text, record) => (
                    <span>
                        {record.destinationCountry}&nbsp;{record.destinationCity}
                    </span>
                )
            }, {
                title: '箱量',
                dataIndex: 'containerNum',
                render: (text, record) => {
                    if (text == null) {
                        return 0;
                    }
                    return text;
                }
            }, {
                title: '预计装箱开始时间',
                sorter: true,
                dataIndex: 'deliveryEstimateDt',
                render: (text, record) => {
                    if (text && text != null) {
                        return text.substr(0, 10);
                    }
                }
            }, {
                title: '提货时间',
                sorter: true,
                dataIndex: 'deliveryTime',
                render: (text, record) => {
                    if (text && text != null) {
                        return text.substr(0, 10);
                    }
                }
            }, {
                title: '订单状态',
                sorter: true,
                dataIndex: 'orderStatus',
                render: (text, record) => (
                    <span>
                        {orderStatus[text]}
                    </span>
                )
            }, {
                title: '物流状态',
                sorter: true,
                dataIndex: 'logisticsStatus',
                render: (text, record) => (
                    <span>
                        {logisticsStatus[text]}
                    </span>
                )
            }, {
                title: '操作',
                dataIndex: 'opt',
                width: 60,
                render: (text, record) => (
                    <span>
                    {record.logisticsStatus === 'cancelled'?null:<AuthLinkButton authority="kt_delivery:edit"
                                       onClick={() => this.props.history.push('/ktTrackInfo', {orderId: record.id})}>编辑</AuthLinkButton>}
                     </span>
                )
            }
        ];
    };

    componentWillMount() {
        this.initColumns()
    }

    getProducts = async (pageNum, sortData) => {
        const pageSize = 10;
        this.setState({
            pageNum: pageNum// 保存pageNum, 让其它方法可以看到
        });
        const {getFieldsValue} = this.props.form;
        const searchData = getFieldsValue();
        const {deliveryFromDt, deliveryToDt} = this.state;
        searchData.deliveryFromDt = deliveryFromDt;
        searchData.deliveryToDt = deliveryToDt;
        searchData.pageNum = pageNum;
        searchData.pageSize = pageSize;
        if (sortData) {
            searchData.sort = sortData.sort;
            searchData.order = sortData.order
        }
        if (!searchData.orderStatus) {
            searchData.notInStatusStr = 'unbooked';
        }
        let result = await reqKtLogisticsList(searchData)
        if (result.code === 200) {
            this.setState({
                total: result.data.total,
                orderList: result.data.rows
            })
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {

        }
    };

    handleSubmit = (event) => {
        // 阻止事件的默认行为
        event.preventDefault();
        // 对所有表单字段进行检验
        this.props.form.validateFieldsAndScroll((err, values) => {
            const {sortData} = this.state;
            if (err) {
                return;
            }
            this.setState({
                searchData: values
            });
            this.getProducts(1, sortData);
        });
    };

    componentDidMount() {
        this.getProducts(1)
    }

    // 日期选择
    onDateChange = (value, dateString) => {
        console.log(value, dateString)
        this.setState({
            deliveryFromDt: dateString
        })
    };
    // 日期选择
    onDateChange2 = (value, dateString) => {
        console.log(value, dateString);
        this.setState({
            deliveryToDt: dateString
        })
    };

    handleTableChange = (pagination, filters, sorter) => {
        const pager = {...this.state.pagination};
        pager.current = pagination.current;
        this.setState({
            pagination: pager,
        });
        const pageNum = pagination.current;
        const sortData = {
            sort: sorter.field,
            order: sorter.order,
        };
        this.setState({
            sortData
        });
        this.getProducts(pageNum, sortData)
    };

    render() {

        const form = this.props.form;
        const {getFieldDecorator} = form;

        const formItemLayout = {
            labelCol: {
                xs: {span: 8},
                sm: {span: 8},
            },
            wrapperCol: {
                xs: {span: 12},
                sm: {span: 12},
            },
        };

        // 取出状态数据
        const {orderList, total} = this.state

        return (
            <div className='box-shadow padding-20'>
                <div className='head-title'>物流信息列表</div>
                <br/>
                <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                    <Row>
                        <Col span={6}>
                            <Form.Item label="订单编号">
                                {getFieldDecorator('orderNo', {
                                    rules: [
                                        {
                                            required: false,
                                        },
                                    ],
                                })(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="起运地">
                                {getFieldDecorator('departure', {
                                    rules: [
                                        {
                                            required: false,
                                        },
                                    ],
                                })(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="目的地">
                                {getFieldDecorator('destination', {
                                    rules: [
                                        {
                                            required: false,
                                        },
                                    ],
                                })(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="订单状态">
                                {getFieldDecorator('orderStatus', {
                                    initialValue: '',
                                    rules: [
                                        {
                                            required: false,
                                        },
                                    ],
                                })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                    <Option value="">全部</Option>
                                    <Option value="booked">订舱成功</Option>
                                    <Option value="declare">待报关</Option>
                                    <Option value="declaring">报关中</Option>
                                    <Option value="released">已放行</Option>
                                    <Option value="cancelled">已取消</Option>
                                </Select>)}
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="物流状态">
                                {getFieldDecorator('logisticsStatus', {
                                    initialValue: '',
                                    rules: [
                                        {
                                            required: false,
                                        },
                                    ],
                                })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                    <Option value="">全部</Option>
                                    <Option value="waiting">待提货</Option>
                                    <Option value="transport">运输中</Option>
                                    <Option value="declaring">报关中</Option>
                                    <Option value="released">已放行</Option>
                                    <Option value="destination">已到达</Option>
                                    <Option value="cancelled">已取消</Option>
                                </Select>)}
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="提货时间">
                                {getFieldDecorator('deliveryFromDt')(<DatePicker
                                    showTime
                                    format="YYYY-MM-DD HH:mm:ss"
                                    onChange={this.onDateChange}
                                    style={{width: '100%'}}
                                />)}
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="至">
                                {getFieldDecorator('deliveryToDt')(<DatePicker
                                    showTime
                                    format="YYYY-MM-DD HH:mm:ss"
                                    onChange={this.onDateChange2}
                                    style={{width: '100%'}}
                                />)}
                            </Form.Item>
                        </Col>
                        <Col span={6} style={{float: 'right', marginBottom: '20px'}}>
                            <Button type='primary' htmlType="submit"
                                    style={{float: 'right', marginRight: '16.7%'}}>查询</Button>
                        </Col>
                    </Row>
                </Form>
                <Table
                    columns={this.columns}
                    dataSource={orderList}
                    rowKey='id'
                    bordered
                    onChange={this.handleTableChange}
                    pagination={{
                        current: this.state.pageNum,
                        total: total,
                        showQuickJumper: true,
                    }}
                    size="middle"
                />
            </div>
        )
    }
}
const KtTrackListForm = Form.create()(KtTrackList);
export default KtTrackListForm